{
  "name": "stage",
  "sunDir": [
    0.3,
    -0.72,
    -0.62
  ],
  "sunColor": "#FFFFFF",
  "sunIntensity": 3.0,
  "skyColor": "#D0D4E8",
  "groundColor": "#2A2438",
  "hemiIntensity": 1.7,
  "fogAmount": 0.85,
  "tint": "#FFFFFF",
  "tintAmount": 0,
  "valueScale": 1
}